export enum LogLevelEnum {
   DEBUG,
   INFO,
   WARNING,
   ERROR,
   NONE,
}
